@use "../../styles/breakpoint.module.scss" as *;

.root {
    grid-column: content;
}

.tabListWrapper {
    position: relative;
    margin-bottom: var(--spacer-16);

    @media ($below-mobile) {
        &[data-overflow-left="true"]::before,
        &[data-overflow-right="true"]::after {
            content: "";
            position: absolute;
            top: 0;
            width: 50px;
            height: 100%;
            z-index: 1;
            pointer-events: none;
        }

        &[data-overflow-left="true"]::before {
            left: 0;
            background: linear-gradient(
                270deg,
                rgb(from var(--white) r g b / 0%) 0%,
                var(--white) 100%
            );
        }

        &[data-overflow-right="true"]::after {
            right: 0;
            background: linear-gradient(
                90deg,
                rgb(from var(--white) r g b / 0%) 0%,
                var(--white) 100%
            );
        }
    }
}

.tabList {
    display: flex;
    align-items: center;
    gap: var(--spacer-48);

    @media ($below-mobile) {
        overflow-x: auto;
        scrollbar-width: none;
        -webkit-overflow-scrolling: touch;
        flex-wrap: nowrap;
        padding: 0 var(--spacer-24);

        &::-webkit-scrollbar {
            display: none;
        }
    }
}

.tab {
    composes: fontST20 from "../../styles/typography.module.scss";
    font-weight: 800;
    cursor: pointer;
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    padding: var(--spacer-16) 0;
    color: var(--black);
    white-space: nowrap;
    flex-shrink: 0;
    transition:
        color 0.2s,
        border-color 0.2s;

    &:first-child {
        margin-left: auto;
    }

    &:last-child {
        margin-right: auto;
    }

    &[data-selected] {
        color: var(--red);
        border-bottom-color: var(--red);
    }

    &[data-hovered] {
        color: var(--red);
    }

    & + & {
        position: relative;

        &::before {
            content: "";
            position: absolute;
            left: calc(var(--spacer-48) * -0.5 - 0.5px);
            top: 50%;
            transform: translateY(-50%);
            width: 1px;
            height: 24px;
            background: var(--mid-gray);
        }
    }
}

.panel {
    display: grid;
    grid-template-columns: 4fr 8fr;
    gap: var(--spacer-gutter);
    align-items: start;
    background: var(--neutral);

    @media ($below-tablet) {
        grid-template-columns: 1fr;
        gap: 0;
    }
}

.textBlock {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--spacer-16);
    padding: var(--spacer-40) 0 var(--spacer-40) var(--spacer-40);

    @media ($below-tablet) {
        padding: var(--spacer-40);
        text-align: center;
    }
}

.headline {
    composes: fontHB56 from "../../styles/typography.module.scss";
    font-feature-settings: normal;
}

.body {
    composes: fontP20 from "../../styles/typography.module.scss";
}

.mediaBlock {
    position: relative;
    height: 100%;
    overflow: hidden;

    @media ($below-tablet) {
        order: 1;
    }
}

.media {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
